module.exports = __webpack_public_path__ + "static/hero-image-desktop-dff340f517d8a5a08411a95de480e457.jpg";